var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"inner"},[_c('a',{staticClass:"webstock",attrs:{"href":"https://www.wenhua.com.cn/","target":"_blank"}},[_vm._v("文华财经官网")]),_c('p',{domProps:{"innerHTML":_vm._s('© 版权所有&nbsp;&nbsp;&nbsp;上海文华财经资讯股份有限公司&nbsp;&nbsp;&nbsp;ICP证号：沪B2-20110035')}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }